import "@/App.css";
import useLenis from "@/hooks/useLenis";
import { Toaster } from "@/components/ui/sonner";
import { PolicyProvider } from "@/components/PolicyContext";

import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import Recommender from "@/components/Recommender";
import BridalJourney from "@/components/BridalJourney";
import Gallery from "@/components/Gallery";
import InstagramSection from "@/components/InstagramSection";
import About from "@/components/About";
import AppointmentForm from "@/components/AppointmentForm";
import Contact from "@/components/Contact";
import Faq from "@/components/Faq";
import Footer from "@/components/Footer";
import MobileContactBar from "@/components/MobileContactBar";
import CookieConsent from "@/components/CookieConsent";

export default function App() {
  useLenis();

  return (
    <PolicyProvider>
      <div className="App bg-ivory">
        <Header />
        <main>
          <Hero />
          <Marquee />
          <Services />
          <Recommender />
          <BridalJourney />
          <Gallery />
          <InstagramSection />
          <About />
          <AppointmentForm />
          <Contact />
          <Faq />
        </main>
        <Footer />
        {/* spacer so fixed mobile contact bar doesn't cover footer */}
        <div className="h-16 lg:hidden bg-espresso" aria-hidden="true" />
        <MobileContactBar />
        <CookieConsent />
        <Toaster position="top-center" richColors />
      </div>
    </PolicyProvider>
  );
}
